import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Slug } from "./Motion";
import { LOGLINE, CONCEPT, SPECS } from "@/data/minka";

export const Logline = () => (
  <section className="relative px-5 py-28 md:px-10 md:py-40" data-testid="logline-section">
    <div className="mx-auto grid max-w-[1400px] gap-10 md:grid-cols-[220px_1fr]">
      <Reveal><Slug>Logline · 一行</Slug></Reveal>
      <Reveal delay={0.1}>
        <p data-testid="hero-logline" className="font-serif-i text-2xl leading-snug text-[#E2E0D8] sm:text-3xl lg:text-[2.6rem] lg:leading-[1.2]">
          {LOGLINE}
        </p>
      </Reveal>
    </div>
  </section>
);

const Specs = () => (
  <div className="grid grid-cols-1 gap-px overflow-hidden border border-white/10 bg-white/10 sm:grid-cols-2" data-testid="spec-grid">
    {SPECS.map((s, i) => (
      <Reveal key={s.k} delay={i * 0.08} className="bg-[#0E1017]/95 p-6 transition-colors duration-500 hover:bg-[#131620]">
        <p className="font-mono-s text-xs uppercase tracking-[0.25em] text-[#A8DADC]">{s.k}</p>
        <p className="mt-3 font-display text-lg text-[#E2E0D8]">{s.v}</p>
      </Reveal>
    ))}
  </div>
);

const Framed = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <div ref={ref} className="relative">
      <Reveal>
        <div className="relative aspect-[4/5] overflow-hidden [clip-path:polygon(0_6%,100%_0,100%_94%,0_100%)]">
          <motion.img style={{ y, scale: 1.25 }} src="/img/interior.jpg" alt="A ghostly samurai at the end of a moonlit farmhouse corridor" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,transparent_30%,rgba(7,8,11,0.85))]" />
        </div>
      </Reveal>
      <p className="mt-4 font-mono-s text-xs uppercase tracking-[0.25em] text-[#A3ACBB]">INT. MINKA — CORRIDOR — NIGHT</p>
    </div>
  );
};

export const Concept = () => (
  <section className="relative bg-[#07080B]/85 px-5 py-28 md:px-10 md:py-40" data-testid="concept-section">
    <div className="mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-[5fr_6fr]">
      <div className="lg:sticky lg:top-28 lg:self-start">
        <Framed />
      </div>
      <div>
        <Reveal><Slug>The Concept · 構想</Slug></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-3xl font-bold leading-tight text-[#E2E0D8] sm:text-4xl lg:text-5xl">
            A classic haunted-house story <span className="font-serif-i font-normal text-[#E76F51]">with a contemporary twist.</span>
          </h2>
        </Reveal>
        <div className="mt-10 space-y-6">
          {CONCEPT.map((p, i) => (
            <Reveal key={i} delay={0.05}>
              <p className="text-base leading-relaxed text-[#C3CAD5] md:text-lg">{p}</p>
            </Reveal>
          ))}
        </div>
        <div className="mt-14"><Specs /></div>
      </div>
    </div>
  </section>
);
